module.exports = __webpack_public_path__ + "img/fb12.0c977c25.jpg";